"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwoLinesAnnotationPositioners = exports.OneLineAnnotationPositioners = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _datasetUtils = require("./datasetUtils");
var _getPercentOfRange = require("./getPercentOfRange");
var _utils = require("./utils");
/**
 * Набор констант для управления сдвигом лейблов, когда они пересекаются
 * Были подобраны методом научного тыка
 * */
const Y_DISTANCE_THRESHOLD = 0.18;
const Y_DISTANCE_MIDDLE_THRESHOLD = 0.3;
const MAX_Y_ADJUST = 20;
const MIN_Y_ADJUST = 4;
/** Варианты расположения точки по Y на графике. Верхняя, нижняя половины или центр графика */
var EPricePos = /*#__PURE__*/function (EPricePos) {
  EPricePos["Up"] = "Up";
  EPricePos["Down"] = "Down";
  EPricePos["Center"] = "Center";
  return EPricePos;
}(EPricePos || {});
/** Возвращает позицию точки на графике по Y: нижняя, верхняя половины или центр */
function getPricePosition(price, minPrice, maxPrice) {
  const percent = (0, _getPercentOfRange.getPercentOfRange)(price, minPrice, maxPrice);
  if (percent < 0.5) {
    return EPricePos.Down;
  }
  if (percent > 0.5) {
    return EPricePos.Up;
  }
  return EPricePos.Center;
}

/**
 * Класс предоставляет методы настройки позиционирования лейблов для двух линий на графике
 * Важно, что проверка на существование двух линий внутри класса не делается! Проверка снаружи обязательно должна быть!
 * */
class TwoLinesAnnotationPositioners {
  constructor() {
    /**
     * Функция рассчитывает значение опции position.y для лейблов графика
     * Опция может иметь значения start, end, center и играет роль vertical align лейбла относительно точки,
     * к которой лейбл принадлежит.
     * Значение выбирается в зав-ти от положения точки на графике
     * */
    (0, _defineProperty2.default)(this, "basicPositionY", options => ctx => {
      const {
        linesPoints,
        distanceBetweenPoints
      } = options;
      const {
        min,
        max
      } = ctx.chart.scales.y;
      const {
        thisPoint,
        otherPoint
      } = linesPoints;
      const thisPointPos = getPricePosition(thisPoint.price, min, max);
      const otherPointPos = getPricePosition(otherPoint.price, min, max);

      /**
       * Если точки лежат по разные половины графика, и расстояние между ними мало,
       * то лейблы сместятся вверх
       * */
      if (thisPointPos !== otherPointPos && distanceBetweenPoints <= Y_DISTANCE_MIDDLE_THRESHOLD) {
        return 'end';
      }

      /** Если точка в верхней половине графика, то лейбл сместится вниз. В остальных случаях - вверх */
      return thisPointPos === EPricePos.Up ? 'start' : 'end';
    });
    /**
     * Функция управляют сдвигом лейблов по вертикали
     * Лейбл - надпись рядом с точкой. Отрисовывается с помощью плагина chartjs annotations.
     * Делает так, чтоб лейблы не пересекались по вертикали
     * */
    (0, _defineProperty2.default)(this, "basicYAdjust", options => ctx => {
      const {
        distanceBetweenPoints,
        linesPoints,
        adjustWhenEqual
      } = options;
      const {
        min,
        max
      } = ctx.chart.scales.y;
      const {
        thisPoint,
        otherPoint
      } = linesPoints;
      const thisPointPos = getPricePosition(thisPoint.price, min, max);
      const otherPointPos = getPricePosition(otherPoint.price, min, max);
      const isDifferentChartParts = thisPointPos !== otherPointPos;
      const yAdjustSign = thisPointPos === EPricePos.Down ? -1 : 1;
      const getAdjust = threshold => MAX_Y_ADJUST * (0, _getPercentOfRange.getPercentOfRange)(distanceBetweenPoints, threshold, 0);

      /**
       * Если точки достаточно близко И в разных половинах графика И эта точка ВЫШЕ,
       * то отодвигаем лейбл этой точки ВВЕРХ
       * */
      if (isDifferentChartParts && distanceBetweenPoints < Y_DISTANCE_MIDDLE_THRESHOLD && thisPoint.price > otherPoint.price) {
        return -1 * getAdjust(Y_DISTANCE_MIDDLE_THRESHOLD);
      }

      /** Если расстояние между точками достаточно большое, то требуется минимальный yAdjust */
      if (distanceBetweenPoints >= Y_DISTANCE_THRESHOLD) {
        return yAdjustSign * MIN_Y_ADJUST;
      }
      const adjust = getAdjust(Y_DISTANCE_THRESHOLD);

      /**
       *  Если эта точка в середине или в верхней половине графика И эта точка НИЖЕ,
       *  то отодвигаем лейбл этой точки ВНИЗ
       *  */
      if ([EPricePos.Up, EPricePos.Center].includes(thisPointPos)) {
        if (thisPoint.price < otherPoint.price || adjustWhenEqual && thisPoint.price === otherPoint.price) {
          return adjust;
        }
      }

      /**
       * Если эта точка в нижней половине графика И эта точка ВЫШЕ,
       * то отодвигаем лейбл этой точки ВВЕРХ
       *  */
      if (thisPointPos === EPricePos.Down) {
        if (thisPoint.price > otherPoint.price || adjustWhenEqual && thisPoint.price === otherPoint.price) {
          return -1 * adjust;
        }
      }
      return 0;
    });
    (0, _defineProperty2.default)(this, "estimationValuePositionY", ctx => {
      const _ctx = (0, _utils.ensureCtx)(ctx);
      const {
        offerPricePoint,
        estimationPricePoint
      } = (0, _datasetUtils.getLinesEndPoints)(_ctx);
      const distanceBetweenPoints = (0, _datasetUtils.getDistanceBetweenEnds)(_ctx);
      return this.basicPositionY({
        distanceBetweenPoints,
        linesPoints: {
          thisPoint: (0, _utils.ensurePoint)(estimationPricePoint),
          otherPoint: (0, _utils.ensurePoint)(offerPricePoint)
        }
      })(_ctx);
    });
    (0, _defineProperty2.default)(this, "offerValuePositionY", ctx => {
      const _ctx = (0, _utils.ensureCtx)(ctx);
      const {
        offerPricePoint,
        estimationPricePoint
      } = (0, _datasetUtils.getLinesEndPoints)(_ctx);
      const distanceBetweenPoints = (0, _datasetUtils.getDistanceBetweenEnds)(_ctx);
      return this.basicPositionY({
        distanceBetweenPoints,
        linesPoints: {
          thisPoint: (0, _utils.ensurePoint)(offerPricePoint),
          otherPoint: (0, _utils.ensurePoint)(estimationPricePoint)
        }
      })(_ctx);
    });
    (0, _defineProperty2.default)(this, "estimationPriceYAdjust", ctx => {
      const _ctx = (0, _utils.ensureCtx)(ctx);
      const {
        offerPricePoint,
        estimationPricePoint
      } = (0, _datasetUtils.getLinesEndPoints)(_ctx);
      const distanceBetweenPoints = (0, _datasetUtils.getDistanceBetweenEnds)(_ctx);
      return this.basicYAdjust({
        distanceBetweenPoints,
        linesPoints: {
          thisPoint: (0, _utils.ensurePoint)(estimationPricePoint),
          otherPoint: (0, _utils.ensurePoint)(offerPricePoint)
        },
        adjustWhenEqual: true
      })(_ctx);
    });
    (0, _defineProperty2.default)(this, "offerPriceYAdjust", ctx => {
      const _ctx = (0, _utils.ensureCtx)(ctx);
      const {
        offerPricePoint,
        estimationPricePoint
      } = (0, _datasetUtils.getLinesEndPoints)(_ctx);
      const distanceBetweenPoints = (0, _datasetUtils.getDistanceBetweenEnds)(_ctx);
      return this.basicYAdjust({
        distanceBetweenPoints,
        linesPoints: {
          thisPoint: (0, _utils.ensurePoint)(offerPricePoint),
          otherPoint: (0, _utils.ensurePoint)(estimationPricePoint)
        },
        adjustWhenEqual: false
      })(_ctx);
    });
  }
  /** Функции для базового позиционирования лейбла относительно линии на графике */
  getYOfferPriceValue(ctx) {
    const {
      offerPricePoint
    } = (0, _datasetUtils.getLinesEndPoints)((0, _utils.ensureCtx)(ctx));
    return (0, _utils.ensurePoint)(offerPricePoint).price;
  }
  getXOfferPriceValue(ctx) {
    const {
      offerPricePoint
    } = (0, _datasetUtils.getLinesEndPoints)((0, _utils.ensureCtx)(ctx));
    return (0, _utils.ensurePoint)(offerPricePoint).date;
  }
  getYEstimationPriceValue(ctx) {
    const {
      estimationPricePoint
    } = (0, _datasetUtils.getLinesEndPoints)((0, _utils.ensureCtx)(ctx));
    return (0, _utils.ensurePoint)(estimationPricePoint).price;
  }
  getXEstimationPriceValue(ctx) {
    const {
      estimationPricePoint
    } = (0, _datasetUtils.getLinesEndPoints)((0, _utils.ensureCtx)(ctx));
    return (0, _utils.ensurePoint)(estimationPricePoint).date;
  }
}

/**
 * Класс предоставляет методы для настройки позиционирования лейбла.
 * Лейбл отображается на последней точке (правый край графика)
 * В классе подразумевается, что линия на графике одна. Если их на самом деле будет две, будет работать неправильно
 * */
exports.TwoLinesAnnotationPositioners = TwoLinesAnnotationPositioners;
class OneLineAnnotationPositioners {
  constructor() {
    (0, _defineProperty2.default)(this, "_getLinePoint", ctx => {
      const _ctx = (0, _utils.ensureCtx)(ctx);
      const {
        estimationPricePoint,
        offerPricePoint
      } = (0, _datasetUtils.getLinesEndPoints)(_ctx);
      return (0, _utils.ensureTwoPoints)(estimationPricePoint, offerPricePoint);
    });
    (0, _defineProperty2.default)(this, "getPositionY", ctx => {
      const linePoint = this._getLinePoint(ctx);
      const {
        min,
        max
      } = ctx.chart.scales.y;
      const pointPos = getPricePosition(linePoint.price, min, max);

      /** Если точка в верхней половине графика, то лейбл сместится вниз. В остальных случаях - вверх */
      return pointPos === EPricePos.Up ? 'start' : 'end';
    });
    (0, _defineProperty2.default)(this, "getYAdjust", ctx => {
      const thisPoint = this._getLinePoint(ctx);
      const {
        min,
        max
      } = ctx.chart.scales.y;
      const thisPointPos = getPricePosition(thisPoint.price, min, max);

      /** Если точка в верхней половине графика, то лейбл дополнительно сместится вниз. В остальных случаях - вверх */
      const yAdjustSign = thisPointPos === EPricePos.Up ? 1 : -1;
      return yAdjustSign * MIN_Y_ADJUST;
    });
  }
  /** Функции для базового позиционирования лейбла относительно линии на графике */
  getYVal(ctx) {
    const {
      estimationPricePoint,
      offerPricePoint
    } = (0, _datasetUtils.getLinesEndPoints)((0, _utils.ensureCtx)(ctx));
    return (0, _utils.ensureTwoPoints)(estimationPricePoint, offerPricePoint).price;
  }
  getXVal(ctx) {
    const {
      estimationPricePoint,
      offerPricePoint
    } = (0, _datasetUtils.getLinesEndPoints)((0, _utils.ensureCtx)(ctx));
    return (0, _utils.ensureTwoPoints)(estimationPricePoint, offerPricePoint).date;
  }
}
exports.OneLineAnnotationPositioners = OneLineAnnotationPositioners;